import { useEffect, useMemo, useState } from "react";
import { useCollections, useVideos, useWatchlist } from "@/hooks";
import { WatchlistItem } from "@/api";
import { ITEM_TYPE_COLLECTION, ITEM_TYPE_VIDEO } from "@/const.ts";
import { SaveToPlaylistProps } from "../types.ts";

const EMPTY_WATCHLIST: WatchlistItem[] = [];

export const useWatchlistDrawer = ({
  ItemId,
  ItemType,
}: Pick<SaveToPlaylistProps, "ItemId" | "ItemType">) => {
  const { data, isInWatchlist } = useWatchlist();
  const watchlist = data?.Watchlist ?? EMPTY_WATCHLIST;
  const [watchlisted, setWatchlisted] = useState(false);
  const currentlyWatchlisted = isInWatchlist({ id: ItemId, type: ItemType });

  useEffect(() => {
    if (data) {
      setWatchlisted(isInWatchlist({ id: ItemId, type: ItemType }));
    }
  }, [ItemId, ItemType, data, isInWatchlist]);

  // Lookup the details of the first item in each playlist
  // This is to render thumbnails for the playlist items
  const { videoIds, collectionIds } = useMemo(() => {
    const videoIds: number[] = [];
    const collectionIds: number[] = [];

    // Get the first item in watchlist
    watchlist.find((w) => {
      if (w.ItemType === ITEM_TYPE_COLLECTION) {
        collectionIds.push(parseInt(w.ItemId));
      }
      if (w.ItemType == ITEM_TYPE_VIDEO) {
        videoIds.push(parseInt(w.ItemId));
      }
      return w;
    });

    return { videoIds, collectionIds };
  }, [watchlist]);
  const { videoById } = useVideos({ ids: videoIds });
  const { collectionById } = useCollections({ ids: collectionIds });

  const firstWatchlistItem = useMemo(() => {
    const w = watchlist.length > 0 ? watchlist[0] : undefined;
    if (w && videoById && collectionById) {
      return w.ItemType === ITEM_TYPE_VIDEO
        ? videoById[parseInt(w.ItemId)]
        : collectionById[parseInt(w.ItemId)];
    }
  }, [watchlist, videoById, collectionById]);

  return {
    watchlist,
    watchlisted,
    setWatchlisted,
    currentlyWatchlisted,
    firstWatchlistItem,
    isLoading: !data,
  };
};
